/**
 * @fileoverview 业务数据（枚举）消费 API
 * @description 按功能 Key 拉取已启用选项，供下拉等场景使用。CCTOWER-2768
 */

import { request } from '@/utils/http'

export interface SysEnumOptionVO {
  itemCode?: string | null
  itemValue?: string | null
  enName?: string | null
  channel?: string | null
  sortOrder?: number | null
  extensionData?: ExtensionDataItem[] | null
}

export interface ExtensionDataItem {
  extensionKey?: string | null
  extensionDescription?: string | null
  extensionValue?: string | null
}

const ENUM_ITEM_BASE = '/sys/enumItem'

/** 按功能 Key 查询已启用业务数据 */
export const listEnumItemsByTypeCode = (typeCode: string, channel?: string) => {
  return request.post<SysEnumOptionVO[]>(`${ENUM_ITEM_BASE}/listByTypeCode`, {
    typeCode,
    channel
  })
}
